<template>
  <div class="asc-chip-button-container">
    <v-btn
      v-bind="$attrs"
      :class="['asc-chip-button', isActive ? 'asc-chip-button--active' : null]"
      v-on="buttonListeners"
    >
      {{ buttonText }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'AscChipButton',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      required: true,
    },
  },

  computed: {
    isActive() {
      return this.value
    },
    buttonListeners() {
      return {
        click: this.handleClick,
      }
    },
  },

  methods: {
    handleClick() {
      this.$emit('input', !this.value)
      this.$emit('toggle', !this.value)
    },
  },
}
</script>

<style lang="scss">
.asc-chip-button-container {
  padding: 0;
  margin-top: auto;

  & .asc-chip-button {
    transition: all 0.3s ease;
    background-color: $gray-0 !important;
    border-radius: 2px;
    text-transform: inherit;
    max-height: 32px !important;
    padding: 6px 15px !important;

    .v-btn {
      &__content {
        color: $primary-black;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 18px;
        text-transform: uppercase;
        font-weight: normal;
      }
    }

    &--active {
      background-color: $accent-200 !important;
    }

    &:hover {
      background-color: $accent-100 !important;
    }

    &.v-btn {
      box-shadow: none !important;
    }
  }
}
</style>
